import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content bg-dark text-light"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left cursor-pointer" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventDetailModal = _resolveComponent("EventDetailModal")!
  const _component_FullSizeGalleryModal = _resolveComponent("FullSizeGalleryModal")!
  const _component_ModalImagesGallery = _resolveComponent("ModalImagesGallery")!
  const _component_ModalEventGallery = _resolveComponent("ModalEventGallery")!
  const _component_ModalContacts = _resolveComponent("ModalContacts")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.updateCount !== 0)
      ? (_openBlock(), _createBlock(_component_EventDetailModal, {
          "parent-modal": _ctx.id,
          id: _ctx.id + 'EventModal',
          event: _ctx.currEvent,
          key: _ctx.updateCount
        }, null, 8, ["parent-modal", "id", "event"]))
      : _createCommentVNode("", true),
    (_ctx.artist)
      ? (_openBlock(), _createBlock(_component_FullSizeGalleryModal, {
          key: 1,
          imgs: _ctx.artist.galleryImages,
          img: _ctx.currImg,
          id: _ctx.id+'ImageGallery',
          "parent-modal": _ctx.id
        }, null, 8, ["imgs", "img", "id", "parent-modal"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.id,
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.artist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.parentModal)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "clean-btn me-4",
                      "data-bs-toggle": "modal",
                      "data-bs-target": '#' + _ctx.parentModal,
                      "data-bs-dismiss": "modal"
                    }, _hoisted_7, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.artist.title), 1),
                _hoisted_9
              ]),
              (_ctx.artist.headerImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.artist.headerImage,
                    class: "modal-header-image"
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  innerHTML: _ctx.artist.description
                }, null, 8, _hoisted_12),
                (_openBlock(), _createBlock(_component_ModalImagesGallery, {
                  id: _ctx.id+'ImageGallery',
                  galleryImages: _ctx.artist.galleryImages,
                  key: _ctx.updateCount,
                  onChange: _ctx.setCurrImage
                }, null, 8, ["id", "galleryImages", "onChange"])),
                (_openBlock(), _createBlock(_component_ModalEventGallery, {
                  id: _ctx.id+'EventModal',
                  events: _ctx.artist.events,
                  key: _ctx.updateCount,
                  onChange: _ctx.setCurrEvent
                }, null, 8, ["id", "events", "onChange"])),
                _createVNode(_component_ModalContacts, {
                  contacts: _ctx.artist.contacts
                }, null, 8, ["contacts"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_1)
  ], 64))
}